module.exports = __webpack_public_path__ + "static/media/gold_member_banner.105ef34c.webp";